import TableSets from "./TableSets";
export default TableSets;
export { default as TableSets } from './TableSets';